import React from 'react';
import styles from './styles.module.scss';

const Card: React.FC<{children: React.ReactNode}> = ({children}) => {
  return <div className={styles.wrapper}>{children}</div>;
};

export default Card;
